// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StatsPanel-StatsPanel-wrapper-1pH6GeC2"};